export default __webpack_public_path__ + "static/media/sa-10-1.51f9b49b.png";